export { CompoundButton, renderCompoundButton, useCompoundButton } from './components/CompoundButton';
export type { CompoundButtonProps, CompoundButtonSlots, CompoundButtonState } from './components/CompoundButton';
